/* eslint-disable */
import { Box } from '@material-ui/core';
import React, { useMemo } from 'react';
import { ReferenceField, TextField, useTranslate } from 'react-admin';
import { useSelector } from 'react-redux';
import { useReportContext } from '../../../base/components/reports/ReportLayout';
import { DEFAULT_CONSOLIDATED_CODE_FOR_INVOICING_REPORT, REPORT_TYPES } from '../../../constant';
import resourceSlug from '../../../constant/resource-slug';
import { LIST_REPORTS } from '../report-invoicing.list';
import Empty from '../../../base/components/empty';
import CustomReportTable from '../../../base/components/reports/CustomReportTable';

const InvoicingReportResults = () => {
  const translate = useTranslate();
  const { data, loading: loadingAllData } = useReportContext();

  const hasNoData = useMemo(() => {
    const totalTableNoData = Object.values(data).reduce((totalNoDataTable, table) => {
      if (!table?.total && Array.isArray(table?.data)) {
        return totalNoDataTable + 1;
      }
      return totalNoDataTable;
    }, 0);
    return totalTableNoData === LIST_REPORTS.length && !loadingAllData;
  }, [data, loadingAllData]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        gap: 24,
      }}
    >
      {hasNoData ? (
        <Empty />
      ) : (
        <>
          <CommonReportTable title={translate('resources.report.overall')} reportType={REPORT_TYPES.OVERALL} />
          <PrepaidTable title={translate('resources.report.prepaid')} />
          <CommonReportTable title={translate('resources.report.standard')} reportType={REPORT_TYPES.STANDARD} />
        </>
      )}
    </Box>
  );
};

const CommonReportTable = ({ title, reportType }) => {
  const translate = useTranslate();
  const { appliedFilters } = useReportContext();
  const currenciesList = useSelector(({ admin }) => admin.resources.currency.data);
  const targetCurrencyCode =
    currenciesList?.[appliedFilters?.consolidated]?.code || DEFAULT_CONSOLIDATED_CODE_FOR_INVOICING_REPORT;

  return (
    <CustomReportTable
      title={title}
      resource={resourceSlug.REPORT_INVOICING}
      reportList={LIST_REPORTS}
      reportType={reportType}
    >
      <ReferenceField link="show" source="group" reference="group" label="resources.group.name">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField link="show" source="brand" reference="brand" label="resources.brand.name">
        <TextField source="name" />
      </ReferenceField>
      <TextField label="resources.report.fields.turnOver" source="turnOver" sortable />
      <TextField label="resources.report.fields.GGR" source="GGR" sortable />
      <TextField label="resources.report.fields.currencyType" source="currencyType" sortable={false} />
      <ReferenceField link="show" label="resources.currency.name" source="currency" reference="currency">
        <TextField source="code" />
      </ReferenceField>
      <TextField
        label={`${translate('resources.report.fields.GGRConsolidated')} (${targetCurrencyCode})`}
        source="GGRConsolidated"
        sortable
      />
    </CustomReportTable>
  );
};

const PrepaidTable = ({ title }) => {
  const translate = useTranslate();
  const { appliedFilters } = useReportContext();
  const currenciesList = useSelector(({ admin }) => admin.resources.currency.data);
  const targetCurrencyCode =
    currenciesList?.[appliedFilters?.consolidated]?.code || DEFAULT_CONSOLIDATED_CODE_FOR_INVOICING_REPORT;

  return (
    <CustomReportTable
      title={title}
      resource={resourceSlug.REPORT_INVOICING}
      reportList={LIST_REPORTS}
      reportType={REPORT_TYPES.PREPAID}
    >
      <ReferenceField link="show" source="group" reference="group" label="resources.group.name">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField link="show" source="brand" reference="brand" label="resources.brand.name">
        <TextField source="name" />
      </ReferenceField>
      <TextField label="resources.report.fields.turnOver" source="turnOver" sortable />
      <TextField label="resources.report.fields.GGR" source="GGR" sortable />
      <TextField label="resources.prepaid.fields.issuer" source="issuer" sortable={false} />
      <TextField label="resources.report.fields.currencyType" source="currencyType" sortable={false} />
      <ReferenceField link="show" label="resources.currency.name" source="currency" reference="currency">
        <TextField source="code" />
      </ReferenceField>
      <TextField
        label={`${translate('resources.report.fields.GGRConsolidated')} (${targetCurrencyCode})`}
        source="GGRConsolidated"
        sortable
      />
    </CustomReportTable>
  );
};

export default InvoicingReportResults;
